import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../layout";
import { url } from "../../config";
import axios from "axios";
import queryString from "query-string";
import Loader from "../../assets/icons/loader/loader";
import { TabelBooleanText } from "../../components/view-form-components/tabel-cell-view";
import DeleteModal from "../../components/modal/delete-modal";
import Pagination from "../../components/pagination";
import moment from "moment";
import BlogFilterDrawer from "../../components/filter/blog-filter-drawer";
import ExportModal from "../../components/modal/export-modal";

const ListBlogs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");
  const [categoriesList, setCategoriesList] = useState([]);
  const [exportModalShow, setExportModalShow] = useState(false);

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    axios
      .post(`${url}/model/blogs/list`, {
        page: page_no,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        if (res.data.data.rows.length === 0 && page_no > 1) {
          navigate(
            `/blogs/list?page=${page_no - 1}${filters ? `&${filters}` : ""}`,
            { replace: true },
          );
          return;
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  useEffect(() => {
    fetchData();
  }, [page_no, location.search]);

  const searchParams = new URLSearchParams(location.search);
  searchParams.delete("page");
  const filters = searchParams.toString() ? `&${searchParams.toString()}` : "";

  const deleteFnc = (id) => {
    axios
      .post(`${url}/model/blogs/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const filterInputs = [
    {
      label: "blog id",
      type: "text",
      name: "id",
    },
    {
      label: "title",
      type: "text",
      name: "title",
    },
    {
      label: "Category",
      type: "dropdown",
      name: "category_id",
      options: categoriesList,
    },
    {
      label: "author",
      type: "text",
      name: "author",
    },
    {
      label: "content section",
      type: "text",
      name: "content_section",
    },
    {
      label: "read time",
      type: "text",
      name: "read_time",
    },
    {
      label: "published",
      type: "switch",
      name: "published",
    },
    {
      label: "created At",
      type: "date",
      name: "createdAt",
    },
    {
      label: "updated At",
      type: "date",
      name: "updatedAt",
    },
  ];

  const categoryListFnc = async () => {
    axios
      .post(`${url}/dropdown/blog-category`)
      .then((res) => {
        let newArr = res?.data?.data?.categories?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCategoriesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    if (filterDrawerOpen) {
      categoryListFnc();
    }
  }, [filterDrawerOpen]);

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />
      <ExportModal
        isOpen={exportModalShow}
        onClose={() => {
          setExportModalShow(false);
        }}
        tableName={"blogs"}
      />
      <section className="h-full">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-xl font-semibold capitalize">Blogs List</h2>
          <div className="flex gap-2 relative">
            <BlogFilterDrawer
              open={filterDrawerOpen}
              onClose={() => setFilterDrawerOpen(false)}
              queryParamsData={queryParamsData}
              filterInputs={filterInputs}
            />
            <button
              onClick={() => setExportModalShow(true)}
              type="button"
              className="px-4 py-2 bg-gray-500 text-white rounded"
            >
              Export
            </button>
            <Link
              className="px-4 py-2 bg-primary text-white rounded"
              to={`/blogs/create`}
            >
              Create
            </Link>
            <button
              onClick={() => setFilterDrawerOpen(true)}
              className="px-4 py-1 bg-secondary text-white rounded"
            >
              Filters
            </button>
          </div>
        </div>
        <section className="h-[calc(100%-3.5rem)] flex flex-col justify-between overflow-auto">
          <div className="w-full max-w-[82.2vw]  overflow-auto h-full">
            <div class="relative overflow-x-auto">
              <table class="w-full text-left rtl:text-right border border-gray-200">
                <thead class="text-gray-700 uppercase">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      #
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      title
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      category
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      author
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      published
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      date of published
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      created At
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td rowSpan={1}>
                        <div className="w-full flex justify-center py-5">
                          <div className="h-[100px] w-[100px]">
                            <Loader />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {data.rows?.length ? (
                        <>
                          {data.rows.map((row, index) => {
                            return (
                              <tr key={index} className="border-t bg-white">
                                <td className="p-1 px-2">
                                  {(data?.page - 1) * 10 + (index + 1)}
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.title}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.blogsCategory?.name ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.author ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    <TabelBooleanText value={row?.published} />
                                  </span>
                                </td>
                                <td className="px-4 py-2">
                                  {moment(row?.date_of_published).format(
                                    "DD-MM-YYYY HH:MM A",
                                  )}
                                </td>
                                <td className="px-4 py-2">
                                  {moment(row?.createdAt).format(
                                    "DD-MM-YYYY HH:MM A",
                                  )}
                                </td>
                                <td className="py-2 sticky right-0 z-10">
                                  <div className="flex gap-3 bg-white px-4">
                                    <Link
                                      to={`/blogs/view/${row["id"]}`}
                                      className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                    >
                                      View
                                    </Link>
                                    <Link
                                      to={`/blogs/edit/${row["id"]}`}
                                      className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                    >
                                      Edit
                                    </Link>
                                    <button
                                      onClick={() => {
                                        setdeleteModalShow(true);
                                        setSelectDelete(row["id"]);
                                      }}
                                      className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td>
                            <p className="text-center my-5">No data found</p>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <footer className="flex justify-end items-center w-full">
            <Pagination
              totalPages={parseInt(data?.count) ?? 0}
              pagination={parseInt(data?.page) ?? 0}
              path={`/blogs/list`}
              filters={filters}
            />
          </footer>
        </section>
      </section>
    </MainLayout>
  );
};

export default ListBlogs;
